import { useState, useEffect } from 'react';
import { Girl, SwipeyCharacterResponse } from '../types';
import {
  CDN_BASE_URL,
  SWIPEY_BASE_URL,
  DEFAULT_GIRLS_SLUGS,
} from '../config/constants';
import { useGrowthbook } from './useGrowthbook';

const fetchCharactersData = async (
  slugs: string[],
): Promise<SwipeyCharacterResponse[]> => {
  console.log('API', slugs);
  try {
    const response = await fetch(
      `${SWIPEY_BASE_URL}/api/v1/pre-lander/characters`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ slugs }),
      },
    );
    if (!response.ok) return [];
    return await response.json();
  } catch (error) {
    console.error('Failed to fetch characters:', error);
    return [];
  }
};

export const useGirlsData = () => {
  const [girls, setGirls] = useState<Girl[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { features, loading: gbLoading } = useGrowthbook();

  useEffect(() => {
    if (gbLoading) return;

    const fetchGirlsData = async () => {
      try {
        const videoMappings = features.videoMappings;

        const characters = await fetchCharactersData(DEFAULT_GIRLS_SLUGS);

        const validGirls: Girl[] = characters
          .map((data) => {
            const slug = data.slug ?? '';
            const videoPath = videoMappings[slug];
            const videoUrl = videoPath
              ? videoPath.startsWith('https://')
                ? videoPath
                : `${CDN_BASE_URL}/${videoPath}`
              : undefined;
            const imageUrl = data.previews?.[0];

            return {
              id: data._id,
              name: data.name,
              age: data.age ? parseInt(data.age, 10) : 25,
              tags: data.tags ?? [],
              slug,
              video: videoUrl,
              image: imageUrl,
            } as Girl;
          })
          .filter((girl) => girl.slug !== '');

        setGirls(validGirls);
        setLoading(false);
      } catch (err) {
        console.error('Failed to fetch girls dat:', err);
        setError('Failed to load data');
        setLoading(false);
      }
    };

    fetchGirlsData();
  }, [gbLoading, features]);

  return { girls, loading, error };
};
